/**
 * Glass Panel Component
 * Стеклянный эффект панели в стиле Vertex
 * Автор: AI Market Hub
 */

import { motion } from 'framer-motion';

export default function GlassPanel({ 
  children, 
  className = '', 
  hover = true,
  onClick,
  ...props 
}) {
  return (
    <motion.div
      className={`
        glass-panel
        ${className}
        ${onClick ? 'cursor-pointer' : ''}
      `}
      whileHover={hover ? { scale: 1.02, y: -2 } : {}}
      whileTap={onClick ? { scale: 0.98 } : {}}
      onClick={onClick}
      {...props}
    >
      {children}
    </motion.div>
  );
}



